import gsap, { Power3, Linear, ScrollToPlugin } from "gsap/all";
import axios from "axios";
import $ from "jquery";

gsap.registerPlugin(Power3, Linear, ScrollToPlugin);

const isLocal = (location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname === "");


const formQuiz = $('#formQuestion'),
      participationForm = $('#participationForm');


if(formQuiz.length){
    function formQuizHandler(){
        const form = $('#formQuestion'),
              question = $('#question'),
              errorText = $('.form__error'),
              btnSubmit = $('#btnSubmit');

        $(question).on('input', () => {
            if ($(question).val().length < 1) {
                $(question).next(".error").removeClass("hidden");
                return false;
            } else {
                $(question).next(".error").addClass("hidden");
            }
        })
        
        $(form).on('submit', function(e) {
            e.preventDefault();

            if ($(question).val().length < 1) {
                $(question).next(".error").removeClass("hidden");
                return false;
            };

            $(form).addClass('is-sending');
            $(btnSubmit).attr('disabled');

            // data
            localStorage.setItem('question', $(question).val());

            if(isLocal){
                window.location.href = 'contest-form.html';
            } else {
                window.location.href = 'contest-form?lang=' + locale;
            }
        });
    }
    formQuizHandler();
}

if(participationForm.length){
    function formHandler() {
        const form = $(participationForm),
              nameInput = $('#firstName'),
              secondNameInput = $('#secondName'),
              emailInput = $('#userEmail'),
              emailErrorEmpty = $(".error-email-empty"),
              emailErrorIncorrect = $(".error-email-incorrect"),
              emailReg = /\S+@\S+\.\S+/,
              cbx1 = $('#privacy'),
              btn = document.getElementById('btnParticipation');

        function scrollToError(field) {
            const offsetY = $(".header").height() + 100;
            const tl = gsap.timeline();
            tl.to(window, {
                duration: 0.6,
                scrollTo: {
                    y: field,
                    offsetY,
                },
                ease: window.Linear,
            });
        }

        function checkFormFields() {
            if ($(nameInput).val().trim() === "") {
                scrollToError(nameInput);
                setError(nameInput, true);
            }

            if ($(secondNameInput).val().trim() === "") {
                scrollToError(secondNameInput);
                setError(secondNameInput, true);
            }

            if ($(emailInput).val().trim() === '') {
                scrollToError(emailInput);
                setError(emailInput, true);
            }

            return true;
        }

        $(nameInput).on('input', ()=>{
            if ($(nameInput).val().trim() === "") {
                setError(nameInput, true);
            } else {
                setError(nameInput, false);
            }
        })

        $(secondNameInput).on('input', () => {
            if ($(secondNameInput).val().trim() === "") {
                setError(secondNameInput, true);
            } else {
                setError(secondNameInput, false);
            }
        })

        $(emailInput).on('input', ()=>{
            if ($(emailInput).val().trim() === "") {
                setError(emailInput, true);
            } else {
                setError(emailInput, false);
            }
        })

        function setError(e, status) {
            if (status) {
                $(e).addClass('is-error');
                $(e).next('.error').removeClass('hidden');
            } else {
                $(e).removeClass('is-error').removeClass('is-correct');
                $(e).next('.error').addClass('hidden');
            }
        }

        $(cbx1).on('change', () => {
            if ($(cbx1).prop('checked') === true) {
                $(btn).removeAttr('disabled');
            } else {
                $(btn).attr('disabled', 'disabled');
            }
        });

        function resetForm() {
            setTimeout(() => {
                $(form).removeClass('is-sending');
                $(form)[0].reset()
            }, 3000);
        }

        function checkForm() {
            const name = $(nameInput).val();
            const secondName = $(secondNameInput).val();
            const email = $(emailInput).val();
            const privacyChecked = $(cbx1).prop('checked');

            // Checking required fields
            if (!name || !secondName || !email || !privacyChecked) {
                $('body').addClass('show-modal');
                $('#popupCheckFormFields').addClass('is-open');
                return false;
            }

            // Checking data in localStorage for each question
            for (let i = 1; i <= 10; i++) {
                if (!localStorage.getItem(`step${i}`)) {
                    $('body').addClass('show-modal');
                    $('#popupCheckFormStorage').addClass('is-open');
                    $('#popupCheckFormStorage #popupStep').text(`${i}).`);
                    return false;
                }
            }

            // Checking the result
            if (!localStorage.getItem('result')) {
                $('body').addClass('show-modal');
                $('#popupCheckFormResult').addClass('is-open');
                return false;
            }

            // Checking the answer to the question
            if (!localStorage.getItem('question')) {
                $('body').addClass('show-modal');
                $('#popupCheckFormQuestion').addClass('is-open');
                return false;
            }

            return true;
        }

        const query = new URLSearchParams(location.search);
        $(btn).on('click', async function (e) {
            e.preventDefault();
            if (!checkFormFields()) return;
            if (!checkForm()) return;

            const token = await grecaptcha.execute(tokenCaptcha, {
                action: "submit",
            });

            const formD = {
                name: $(nameInput).val(),
                second_name: $(secondNameInput).val(),
                email: $(emailInput).val(),
                q_1: localStorage.getItem('step1'),
                q_2: localStorage.getItem('step2'),
                q_3: localStorage.getItem('step3'),
                q_4: localStorage.getItem('step4'),
                q_5: localStorage.getItem('step5'),
                q_6: localStorage.getItem('step6'),
                q_7: localStorage.getItem('step7'),
                q_8: localStorage.getItem('step8'),
                q_9: localStorage.getItem('step9'),
                q_10: localStorage.getItem('step10'),
                result: localStorage.getItem('result'),
                question: localStorage.getItem('question'),
                privacy: $(cbx1).prop('checked'),
                "g-recaptcha-response": token
            };
            
            $(form).addClass('is-sending');
            $(btn).attr('disabled', 'disabled')

            if (isLocal) {
                console.table(formD);
                $(form).removeClass('is-sending');
                $('body').addClass('show-modal');
                $('#popupAlreadyParticipated').addClass('is-open');
                $(btn).removeAttr('disabled');
                return;
            }

            try {
                const response = await axios.post($(form).attr('action'), formD, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                if (response.status === 200) {
                    if (!response.data.captcha_is_valid) {
                        $(form).removeClass('is-sending');
                        $('body').addClass('show-modal');
                        $('#captchaInvalid').addClass('is-open');
                        $(btn).removeAttr('disabled');
                        return;
                    }

                    localStorage.clear();
                    localStorage.setItem("country_selected", "1");
                    localStorage.setItem("default_lang", query.get("lang") || "nl");

                    setTimeout(() => {
                        window.location.href = 'thanks?lang=' + locale;
                    }, 300);
                } else {
                    $(form).removeClass('is-sending');
                    alert(response.message);
                    $(btn).removeAttr('disabled');
                }
            } catch (err) {
                if (err.response && err.response.data.errors && err.response.data.errors.email) {
                    console.log(2);
                    $(form).removeClass('is-sending');
                    $('body').addClass('show-modal');
                    $('#popupAlreadyParticipated').addClass('is-open');
                    resetForm();
                    return;
                }
                alert(err.message);
                $(form).removeClass('is-sending');
                $(btn).removeAttr('disabled');
            }
        });
    }

    formHandler()
}

